import { Compass } from 'lucide-react'

import { ErrorState } from '@/components/ui/ErrorState'
import { Container } from '@/components/ui/Container'
import { getLocalizedPath } from '@/content/i18n'
import { siteContent } from '@/content/siteContent'
import { useDirection } from '@/hooks/useDirection'
import { useLocale } from '@/hooks/useLocale'
import { getLocalizedValue } from '@/lib/utils'

export function NotFoundPage() {
  const locale = useLocale()
  useDirection(locale)

  return (
    <div className="min-h-[70vh] bg-page-radial py-24">
      <Container className="flex justify-center">
        <ErrorState
          icon={<Compass className="h-6 w-6" />}
          title={getLocalizedValue(siteContent.errors.notFound.title, locale)}
          description={getLocalizedValue(siteContent.errors.notFound.description, locale)}
          actions={[
            { label: getLocalizedValue(siteContent.shared.contactUs, locale), to: getLocalizedPath(locale, 'contact'), variant: 'ghost' },
            { label: locale === 'ar' ? 'العودة للرئيسية' : 'Return home', to: getLocalizedPath(locale) },
          ]}
        />
      </Container>
    </div>
  )
}
